import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { SnackBarService } from "../../../../../cw-utils/snackbar.service";
import { ApiGateway } from "../../../../api-gateway";

@Injectable()
export class ExpressionProvider {
    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService,
    ) {}

    insert(data, idDocumentMOdel: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(`expression/${idDocumentMOdel}/`, data)
                .subscribe((response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                }, reject);
        });
    }

    getPageExpression(documentModelId: number, pageoptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(`expression/search/${documentModelId}`, pageoptions)
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        res.body ? resolve(res.body) : resolve(res);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
        });
    }

    getPageExpressionNotDocumentModel(pageoptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post(`expression/search`, pageoptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    res.body ? resolve(res.body) : resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getListExpression(parentId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get(`expression/${parentId}`).subscribe({
                next: (res: HttpResponse<any>) => {
                    res.body ? resolve(res.body) : resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    async delete(expressionId: number): Promise<HttpResponse<any>> {
        const response = await firstValueFrom(
            this.gw.delete(`expression/${expressionId}`),
        );

        this.snackBar.successMessage(response.body.message);
        return response;
    }

    async deleteToDocumentModel(
        expressionId: number,
        documentModelId: number,
    ): Promise<HttpResponse<any>> {
        const response = await firstValueFrom(
            this.gw.delete(`expression/${expressionId}/${documentModelId}`),
        );

        this.snackBar.successMessage(response.body.message);
        return response;
    }

    getExpressionAndParentList(documentModelId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get(`expression/calculate/${documentModelId}`).subscribe({
                next: (res: HttpResponse<any>) => {
                    res.body ? resolve(res.body) : resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    insertDocumentExpression(data): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(`expression/calculate/`, data)
                .subscribe((response: HttpResponse<any>) => {
                    resolve(response);
                    // this.snackBar.successMessage(response.body.message);
                }, reject);
        });
    }

    checkDocumentModelIsExpression(documentModelId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get(`expression/check/${documentModelId}`).subscribe({
                next: (res: HttpResponse<any>) => {
                    res.body ? resolve(res.body) : resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    checkExpressionExists(variable: string, documentId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get(`expression/value/${variable}/${documentId}`)
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        res.body ? resolve(res.body) : resolve(res);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
        });
    }

    checkDocumentExpressionExists(documentId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get(`expression/checkDocument/${documentId}`).subscribe({
                next: (res: HttpResponse<any>) => {
                    console.log(res);
                    res.body ? resolve(res.body) : resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    replicateExpressionInDocumentModel(
        documentModelId: number,
        expressionId: number,
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get(`expression/replicate/${documentModelId}/${expressionId}`)
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        console.log(res);
                        res.body ? resolve(res.body) : resolve(res);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
        });
    }

    updatePlacementOrder(data: any[]) {
        return firstValueFrom(this.gw.put("expression/order", data));
    }
}
